// Shared list logic for the Positive / Negative Question Set views.
// Extracted to remove duplicated code (SonarQube duplicated lines) without changing behavior.
//
// The consuming component must provide `validationApis` in its data:
//   validationApis: { table: 'GetTableValidationPositive', detailRoute: 'ValidationPositiveDetail' }
// and keeps its own template, styles and delete / search UX.
//
// `Get()` toggles BOTH `loading` and `loadingTable` so each view keeps binding to
// whichever flag it already used in its template (no template change required for loading).
export default {
  data: () => ({
    EditdialogUser: false,
    AddVector: false,
    dialog: false,
    loadingTable: false,
    loading: true,
    today: null,
    searchName: null,
    requestVector: {
      modelType: null,
      modelId: null,
      vectordbName: null,
      entity: null,
    },
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
    },
    dataTable: [],
    isSearch: false,
    isFirst: true,
    searchTotalTable: 0,
    totalTable: 0,
    itemsPerPage: 10,
    showTable: false,
    rules: {
      required: (value) => !!value || "Required.",
    },
    sortBy: [],
    sortDesc: [],
  }),
  watch: {
    options: {
      handler() {
        this.Get();
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    Get() {
      this.loading = true;
      this.loadingTable = true;

      let { page, itemsPerPage, sortBy } = this.options;
      let sortField = null;
      let sortOrder = null;

      if (sortBy && sortBy.length > 0) {
        sortField = sortBy[0].key;
        sortOrder = sortBy[0].order === 'desc';
      }

      let temp = {
        page: this.isSearch ? 1 : page,
        perPage: itemsPerPage == -1 ? this.totalTable : itemsPerPage,
        name: this.searchName,
        sortDesc: sortOrder,
        sortBy: sortField,
      };
      this.$call[this.validationApis.table](
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            this.searchTotalTable = dataResponse.data.total;
            this.dataTable = dataResponse.data.data;
            this.totalTable = this.isFirst
              ? dataResponse.data.total
              : this.totalTable;
            this.options.page = temp.page;
          } else {
            this.dataTable = [];
            this.searchTotalTable = 0;
            this.totalTable = 0;
          }
          this.loading = false;
          this.loadingTable = false;
          this.isSearch = false;
          this.isFirst = false;
        },
        (errorResource) => {
          this.loading = false;
          this.loadingTable = false;
          this.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    Add() {
      this.$router.push({
        name: this.validationApis.detailRoute,
        query: {},
      });
    },
    Edit(item) {
      this.$router.push({
        name: this.validationApis.detailRoute,
        query: {
          id: item.id,
        },
      });
    },
    Clear() {
      this.EditdialogUser = false;
      this.AddVector = false;
      this.showTable = false;

      this.requestVector.entity = null;
      this.requestVector.modelId = null;
      this.requestVector.modelType = null;
      this.requestVector.vectordbName = null;

      this.searchName = null;
    },
    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1;

      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }

      this.today = dd + "/" + mm + "/" + yyyy;
    },
  },
};
